import { Injectable } from '@angular/core';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { map, shareReplay } from 'rxjs/operators';
import { ApplianceDetailsState, ApplianceDetailsStore } from '@modules/appliance-details/state/appliance-details.store';
import { ApplianceDetailsQuery } from '@modules/appliance-details/state/appliance-details.query';
import { OrderQuery } from '@modules/order/state/order-query';
import { ProcedureMap } from '@shared/models/procedure-map';
import { Observable } from 'rxjs';
import { ApplianceTypeEnums } from './models/appliance-type.enum';

@Injectable()
export class ApplianceDetailsFacade {
	applianceTypes$ = this.query.applianceTypes$;

	isReadonly$: Observable<boolean> = this.shellQuery
		.getReadOnlyState('applianceDetails')
		.pipe(shareReplay({ bufferSize: 1, refCount: true }));
	isApplianceUpperReadonly$: Observable<boolean> = this.orderQuery.applianceUpperIsReadonly$.pipe(map(val => val ?? false));
	isApplianceLowerReadonly$: Observable<boolean> = this.orderQuery.applianceLowerIsReadonly$.pipe(map(val => val ?? false));
	procedureMap$: Observable<ProcedureMap | null> = this.orderQuery.procedureMap$;

	get storeState(): ApplianceDetailsState {
		return this.query.getValue();
	}

	constructor(
		protected readonly store: ApplianceDetailsStore,
		protected readonly query: ApplianceDetailsQuery,
		protected readonly shellQuery: ShellQuery,
		protected readonly orderQuery: OrderQuery
	) {}

	updateStore(formValues: ApplianceDetailsState): { formValues: ApplianceDetailsState } {
		this.store.update({
			isUpperChecked: formValues.isUpperChecked,
			isLowerChecked: formValues.isLowerChecked,
			applianceType: formValues.applianceType ? formValues.applianceType : { Id: ApplianceTypeEnums.Empty, Name: '' }
		});

		return { formValues };
	}

	subscribeToStoreChanges(): Observable<ApplianceDetailsState> {
		return this.query.select();
	}

	getSrcForRadioButtonImg(checked: boolean): string {
		const ICONS_PATH = `${this.shellQuery.staticFilesEndpoint}/assets/icons/`;

		return checked ? `${ICONS_PATH}check.svg` : `${ICONS_PATH}uncheck.svg`;
	}
}
